import { render, staticRenderFns } from "./custom-pulse-loader.component.vue?vue&type=template&id=05bc33ef&scoped=true&"
import script from "./custom-pulse-loader.component.vue?vue&type=script&lang=ts&"
export * from "./custom-pulse-loader.component.vue?vue&type=script&lang=ts&"
import style0 from "./custom-pulse-loader.component.vue?vue&type=style&index=0&id=05bc33ef&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05bc33ef",
  null
  
)

export default component.exports